import { formatDate } from '@koob/dates';

export default function ProgramRowHeader({
  title,
  date,
  location,
  // The itinerary opens on an arrival and closes on a departure. Same row, two
  // bullets: hollow where the trip starts, filled where it ends.
  variant = 'arrival',
}) {
  // The row reads as one line: a bullet, the step name, then the day, the date
  // and the city separated by middots.
  const details = [
    date ? formatDate(date, 'dddd DD/MM/YYYY') : '--/--/----',
    location,
  ].filter(Boolean);

  return (
    <div className="flex items-center space-x-2 text-sm">
      <span
        className={[
          'h-3.5 w-3.5 shrink-0 rounded-full border-2 border-solid border-k-h',
          variant === 'departure' && 'bg-k-h',
        ]
          .filter(Boolean)
          .join(' ')}
      />

      <span className="font-semibold text-k-h">{title}</span>

      <span className="font-light text-gray-400">{details.join(' · ')}</span>
    </div>
  );
}
